var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "bil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.91 2.07827C17.685 1.41452 17.055 0.942017 16.3125 0.942017H3.9375C3.195 0.942017 2.57625 1.41452 2.34 2.07827L0 8.81702V17.817C0 18.4358 0.50625 18.942 1.125 18.942H2.25C2.86875 18.942 3.375 18.4358 3.375 17.817V16.692H16.875V17.817C16.875 18.4358 17.3812 18.942 18 18.942H19.125C19.7438 18.942 20.25 18.4358 20.25 17.817V8.81702L17.91 2.07827ZM3.9375 13.317C3.00375 13.317 2.25 12.5633 2.25 11.6295C2.25 10.6958 3.00375 9.94202 3.9375 9.94202C4.87125 9.94202 5.625 10.6958 5.625 11.6295C5.625 12.5633 4.87125 13.317 3.9375 13.317ZM16.3125 13.317C15.3788 13.317 14.625 12.5633 14.625 11.6295C14.625 10.6958 15.3788 9.94202 16.3125 9.94202C17.2462 9.94202 18 10.6958 18 11.6295C18 12.5633 17.2462 13.317 16.3125 13.317ZM2.25 7.69202L3.9375 2.62952H16.3125L18 7.69202H2.25Z",
    fill: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.4bb60e8e.svg";
export { ForwardRef as ReactComponent };